import type { EditorState } from '../store/editorState';

export const getPathsState = (state: EditorState) =>
  state.newAddPanel.pathsState;
